import { render, staticRenderFns } from "./PaymentData.vue?vue&type=template&id=3b5aac70"
import script from "./PaymentData.vue?vue&type=script&lang=js"
export * from "./PaymentData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports